export default "__VITE_ASSET__DJYJN7cA__"